import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'app/core/http/url.service';
import { GoogleCourseModel } from 'app/teacher/models/google-course.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { StudentsSyncDataModel } from 'app/teacher/models/students-sync-data.model';
import { SessionStorageConstants } from 'app/core/kh-utils/session-storage-constants.enum';
import { GoogleStudentModel } from 'app/teacher/models/google-student.model';
import { StudentPreregistrationModel } from 'app/teacher/models/student-preregistration.model';
import { ClassModel } from 'app/teacher/models/class.model';

@Injectable({
  providedIn: 'root'
})
export class TeacherGoogleClassroomDataService {
  public constructor(
    public readonly httpClient: HttpClient,
    public readonly urlService: UrlService) { }

  public getAuthenticationUrl(): Observable<string> {
    const url = this.urlService.buildServerApiUrl('Teacher/GoogleClassroom/AuthUrl');

    return this.httpClient.get<{ Url: string }>(url).pipe(map(({ Url }) => Url));
  }

  public loadClassData(token: string): Observable<GoogleCourseModel[]> {
    const url = this.urlService.buildServerApiUrl('Teacher/GoogleClassroom/LoadData');
    return this.httpClient.post<GoogleCourseModel[]>(url, { Value: token });
  }

  public loadStudentData(googleCourseId: string, token?: string): Observable<GoogleStudentModel[]> {
    const url = this.urlService.buildServerApiUrl(`Teacher/GoogleClassroom/${googleCourseId}/LoadStudents`);
    return this.httpClient.post<GoogleStudentModel[]>(url, { Value: token });
  }

  public getClassData(): Observable<GoogleCourseModel[]> {

    const courses = sessionStorage.getItem(SessionStorageConstants.GoogleClassRoomCourses);

    if (courses) {
      return of(JSON.parse(courses));
    }

    return of([]);
  }

  public getClassWithStudentData(): ClassModel | undefined {
    const course = sessionStorage.getItem(SessionStorageConstants.GoogleClassRoomCourse);
    const students = sessionStorage.getItem(SessionStorageConstants.GoogleClassRoomCourseStudents);
    if (course) {
      let googleCourse: ClassModel = JSON.parse(course);

      googleCourse.Students = (students) ? JSON.parse(students) : [];
      return googleCourse;
    }
    return undefined;
  }  

  public getStudentDifference(googleCourseId: string, classId: string): Observable<StudentsSyncDataModel> {

    const sessionStudents = sessionStorage.getItem(SessionStorageConstants.GoogleClassRoomCourseStudents);

    let students: StudentPreregistrationModel[] = [];

    if (sessionStudents) {
      students = JSON.parse(sessionStudents);
    }

    const url = this.urlService.buildServerApiUrl('Teacher/GoogleClassroom', googleCourseId, 'StudentsDiff', classId);

    return this.httpClient.post<StudentsSyncDataModel>(url, students);
  }

  public syncData(googleCourseId: string, classId: string): Observable<void> {

    const sessionStudents = sessionStorage.getItem(SessionStorageConstants.GoogleClassRoomCourseStudents);

    let students: StudentPreregistrationModel[] = [];

    if (sessionStudents) {
      students = JSON.parse(sessionStudents);
    } 

    const url = this.urlService.buildServerApiUrl('Teacher/GoogleClassroom', googleCourseId, 'SyncData', classId);

    return this.httpClient.post<void>(url, students);
  }
}
